import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { ConsumablesMasterTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<ConsumablesMasterTheme>;
const css = baseCss as ThemedCssFunction<ConsumablesMasterTheme>;

export const ConsumablesMaster = styled.div`
  width: 100%;
  height: 100%;
`;
